import styled from "styled-components";

export const ContainerStyle = styled.div`
  max-width: 1140px;
  margin: 0 auto ;
  padding:  15px;
`